import React from 'react';
import cl from './AboutInfo.module.css';

const AboutInfo = (props) => {
    return (
      <section className={cl.about}>
        <h1>Riguardo alla nostra azienda</h1>
        <p>{props.shopStory}</p>
      </section>
    );
}

export default AboutInfo;
